import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from 'recharts';
import { Point } from '../types';

interface Props {
  data: Point[];
}

const FutureForecast: React.FC<Props> = ({ data }) => (
  <ResponsiveContainer width="100%" height={200}>
    <BarChart data={data}>
      <XAxis dataKey="time" />
      <YAxis />
      <Tooltip />
      <Bar dataKey="value" fill="#52c41a" />
    </BarChart>
  </ResponsiveContainer>
);

export default FutureForecast;
